import { useState } from 'react'
import 'assets/css/purchase.css'
import PurchaseWindowStart from './PurchaseWindowStart';
import PurchaseWindowConfirm from './PurchaseWindowConfirm';
import PurchaseWindowSuccess from './PurchaseWindowSuccess';
import PurchaseWindowFail from './PurchaseWindowFail';
import { useSelector } from 'react-redux';
import PagePopopCloseButton from 'components/page-components/PagePopopCloseButton';
import { useSoundPath } from 'hooks/useSoundPath';
import ModalWindow from 'components/ModalWindow';

const PurchaseWindow = ({close}) => {
  const playSound = useSoundPath();
  const currentQuantity = useSelector((state) => state.popups.quantityPurchase);
  const [step, setStep] = useState('start');
  const [cardPackId, setCardPackId] = useState(0);

  const nextStep = (step) => {
    setStep(step);
    playSound('main')
  }

  const closeWindowHandler = () => {
    close();
    setStep('start');
  }
  return (
    <ModalWindow
      additionalClass="modal-window--purchase"
      close={closeWindowHandler}
    >
      <div
        className="modal-window__wrapper"
        onClick={(e) => e.stopPropagation()}
      >
        <PagePopopCloseButton close={closeWindowHandler} />
        {step === 'start' && <PurchaseWindowStart currentQuantity={currentQuantity} nextStep={nextStep} />}

        {step === 'confirm' && <PurchaseWindowConfirm currentQuantity={currentQuantity} nextStep={nextStep} setCardPackId={setCardPackId} close={closeWindowHandler} />}

        {step === 'success' && <PurchaseWindowSuccess currentQuantity={currentQuantity} close={closeWindowHandler} cardPackId={cardPackId} />}

        {step === 'fail' && <PurchaseWindowFail close={closeWindowHandler} />}
      </div>
    </ModalWindow>
  )
}

export default PurchaseWindow;
